import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
var initalState = {};
export default handleActions({
    'there is no actions in this reducer': function (state) { return (__assign({}, state)); }
}, initalState);
